/**
 * Resumen para tarjetas cuando el API no envía excerpt (fallback en cliente).
 */
export function stripHtmlToText(html) {
    if (!html || typeof html !== "string") return "";
    try {
        const d = document.createElement("div");
        d.innerHTML = html;
        return (d.textContent || d.innerText || "").replace(/\s+/g, " ").trim();
    } catch {
        return "";
    }
}

export function truncateWords(text, maxLen = 240) {
    const t = (text || "").trim();
    if (t.length <= maxLen) return t;
    const cut = t.slice(0, maxLen - 1);
    const i = cut.lastIndexOf(" ");
    return (i > 40 ? cut.slice(0, i) : cut) + "…";
}

export function postListExcerpt(post) {
    const ex = (post.excerpt || "").trim();
    if (ex) return ex;
    if (post.content) return truncateWords(stripHtmlToText(post.content));
    return "";
}

/** ~200 palabras por minuto en español */
export function readingTimeMinutesFromHtml(html) {
    const text = stripHtmlToText(html);
    if (!text) return null;
    const words = text.split(/\s+/).filter(Boolean).length;
    return Math.max(1, Math.round(words / 200));
}
